import '@/scss/style.scss';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//
// All third-party, non-Vue.js libraries should be loaded here
//

import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

//
// Setup Vue.js
//

import { createApp } from 'vue';
import { apolloProvider } from './config/apollo.js';
import { store } from './store/index.js';

//
// Components
//
import { Carousel, CarouselSlide } from './components/carousel';
import Checkout from './components/checkout/Checkout.vue';
import CheckoutAddress from './components/checkout/CheckoutAddress.vue';
import CheckoutLine from './components/checkout/CheckoutLine.vue';
import CheckoutNewAddress from './components/checkout/CheckoutNewAddress.vue';
import CheckoutShipping from './components/checkout/CheckoutShipping.vue';
import Event from './components/Event.vue';
import LabeledDropdown from './components/LabeledDropdown.vue';
import LabeledInput from './components/LabeledInput.vue';
import ModalTransition from './components/ModalTransition.vue';
import MoneyFormat from './components/MoneyFormat.vue';
import Navigation from './components/Navigation.vue';
import Popup from './components/Popup.vue';
import Product from './components/Product.vue';
import Shop from './components/Shop.vue';
import ShopCategory from './components/ShopCategory.vue';
import ShopFilter from './components/ShopFilter.vue';
import ShopPrice from './components/ShopPrice.vue';
import Stepper from './components/Stepper.vue';
import Voucher from './components/Voucher.vue';

const app = createApp({
    delimiters: ['${', '}'],
    components: {
        Carousel,
        CarouselSlide,
        Navigation,
        Popup,
        ModalTransition,
        Shop,
        ShopCategory,
        ShopPrice,
        ShopFilter,
        Product,
        LabeledDropdown,
        LabeledInput,
        Stepper,
        Checkout,
        CheckoutAddress,
        CheckoutNewAddress,
        CheckoutLine,
        CheckoutShipping,
        MoneyFormat,
        Event,
        Voucher,
    },

    data() {
        return {
            isPopupOpen: false,
        };
    },

    created() {
        // noinspection JSIgnoredPromiseFromCall
        this.$store.dispatch('cart/loadCart');

        if (!localStorage.popup) {
            setTimeout(() => {
                this.isPopupOpen = true;
            }, 5000);
        }
    },

    methods: {
        onClosePopup() {
            this.isPopupOpen = false;
            localStorage.popup = 'true';
        },
    },
});

app.use(store);

app.use(apolloProvider);

app.mount('#app');
